var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24682",
    "data-name": "Path 24682",
    d: "M1484.5-1430a67.5,67.5,0,0,0,67.5-67.5,67.5,67.5,0,0,0-67.5-67.5,67.5,67.5,0,0,0-67.5,67.5A67.5,67.5,0,0,0,1484.5-1430Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24681",
    "data-name": "Path 24681",
    d: "M0-1258H1920v-342H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24698",
    "data-name": "Path 24698",
    d: "M1455-1467h60v-60h-60Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6766",
    "data-name": "Rectangle 6766",
    width: 52,
    height: 53,
    transform: "translate(1459 -1523)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24685",
    "data-name": "Path 24685",
    d: "M1509.233-1502.063a8.149,8.149,0,0,1-.462,1.187c-2.108,4.587-5.8,9.828-10.233,12.377-1.541.886-5.387,4.159-6.89,2.377l2.032-5.035a7.631,7.631,0,0,0-2.457-1.627c-4.209-1.883-7.7-4.478-9.152-9.06a20.345,20.345,0,0,1-.479-9.207,11,11,0,0,1,4.383-6.508,20.3,20.3,0,0,1,8.314-4.1,6.671,6.671,0,0,1,1.368-.091c2.079.007,4.741-.7,6.7.261,1.772.872,3.27,3.387,4.23,5.051,2.146,3.718,3.766,9.98,2.673,14.272C1509.253-1502.134,1509.243-1502.1,1509.233-1502.063Zm-15.417,14.345-.065.146a23.724,23.724,0,0,0,9.736-7.1,18.071,18.071,0,0,0,1.945-18c-1.092-2.6-2.951-6.316-5.9-6.979a16.767,16.767,0,0,0-10.6,1.548,9.281,9.281,0,0,0-4.517,4.007,11.157,11.157,0,0,0-.724,5.657c.217,3.368.849,6.91,3.058,9.463a16.3,16.3,0,0,0,5,3.594c1.005.519,4.815,1.563,4.165,3.009Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24688",
    "data-name": "Path 24688",
    d: "M1471.134-1514.05c1.624.31,2.455,3.707,2.879,4.98.737,2.208,1.615,4.306.044,6.331-.745.96-3.274,2.709-3.087,4.062a.728.728,0,0,0,.151.306c3.191,4.459,5.842,10.036,10.942,12.586a.266.266,0,0,0,.216.049.266.266,0,0,0,.178-.13c1.3-1.442,4.3-4.845,6.24-2.419,1.844,2.3,6.439,7.592,4.9,10.767-1.244,2.562-4.832,3.828-7.211,5.023-3.025,1.519-4.721.176-7.355-1.551a41.232,41.232,0,0,1-14.618-17.607,70.59,70.59,0,0,1-2.8-7.237c-.676-2.084-1.752-4.581-1.6-6.808a2.878,2.878,0,0,1,.282-1.115C1461.989-1510.12,1467.165-1514.792,1471.134-1514.05Zm1.39,10.7a8.628,8.628,0,0,0-.873-3.73l-1.329-3.125a3.652,3.652,0,0,0-1.2-1.749,2.464,2.464,0,0,0-2.5.088c-1.709.979-3.623,3.052-3.779,5.07a10.833,10.833,0,0,0,.579,3.791,72.649,72.649,0,0,0,3.687,10.022,38.017,38.017,0,0,0,7.429,11.23,38.658,38.658,0,0,0,6.248,4.827c1.82,1.2,3.884,3.1,6.225,2.9a6.978,6.978,0,0,0,4.511-3.269,2.174,2.174,0,0,0-.227-1.812,35.866,35.866,0,0,0-4.985-7.67c-1.179-1.327-3.383,2.073-4.179,2.9a1.263,1.263,0,0,1-.557.4c-1.325.341-3.585-1.459-4.544-2.206-3.843-2.994-5.861-7.934-7.264-12.457a2.544,2.544,0,0,1-.165-1.054c.136-1.1,1.455-1.544,2.2-2.36a2.893,2.893,0,0,0,.727-1.8Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24691",
    "data-name": "Path 24691",
    d: "M1488.554-1512.079a12.193,12.193,0,0,1,4.923-3.539c1.183-.528,3.172-1.24,3.126.384-.042,1.511-1.475,3.13-1.863,4.6,1.455.043,2.343-1.472,3.788-1.561-.76,2.322-3.368,3.295-5.383,4.256a1.14,1.14,0,0,1-.87.071,1.143,1.143,0,0,1-.665-.566,24.5,24.5,0,0,0,2.753-5.43,1.5,1.5,0,0,0-1.459-.028c-1.021.551-2.025,1.132-3.029,1.715C1489.462-1511.936,1489.081-1511.5,1488.554-1512.079Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24694",
    "data-name": "Path 24694",
    d: "M1500.3-1506.825c-.7-.064-1.188-.106-1.678-.156-.473-.048-1.04.156-1.308-.449.465-1.992,4.268-2.032,5.68-1.351-.091.521-1.92,3.811-2.538,3.613.69.221,1.207.409,1.735.55.555.147.666.312.493.868a2.328,2.328,0,0,1-2.7,1.47c-.995-.095-3.671-.579-2.323-2,.583-.616,1.258-1.145,1.882-1.724C1499.762-1506.21,1499.95-1506.445,1500.3-1506.825Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24697",
    "data-name": "Path 24697",
    d: "M1498.046-1498.838h2.764c-.374,2.872-5.67,2.519-4.752.684.177-.353.412-.676.677-1.105-.886-.058-1.629.547-2.514.025,1.309-1.634,3.408-1.717,5.076-2.7C1499.321-1501.563,1498.423-1498.838,1498.046-1498.838Z",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74260",
    "data-name": "Group 74260",
    transform: "translate(-1043.043 -4609)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49664",
    "data-name": "Group 49664",
    transform: "translate(-373.957 6174)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49663",
    "data-name": "Group 49663",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24680",
    "data-name": "Path 24680",
    d: "M1412-1570h145v145H1412Z",
    fill: "#7bda76"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49677",
    "data-name": "Group 49677",
    transform: "translate(-373.957 6174)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49676",
    "data-name": "Group 49676",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_49675",
    "data-name": "Group 49675",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49666",
    "data-name": "Group 49666",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49665",
    "data-name": "Group 49665",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24683",
    "data-name": "Path 24683",
    d: "M1476.276-1527h38.337v46.4h-38.337Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49668",
    "data-name": "Group 49668",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49667",
    "data-name": "Group 49667",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24686",
    "data-name": "Path 24686",
    d: "M1455-1519.129h43.905v52.3H1455Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49670",
    "data-name": "Group 49670",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49669",
    "data-name": "Group 49669",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24689",
    "data-name": "Path 24689",
    d: "M1483.554-1521.238h19.974v18.426h-19.974Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49672",
    "data-name": "Group 49672",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49671",
    "data-name": "Group 49671",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24692",
    "data-name": "Path 24692",
    d: "M1492.289-1514.179h15.7v16.956h-15.7Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49674",
    "data-name": "Group 49674",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49673",
    "data-name": "Group 49673",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24695",
    "data-name": "Path 24695",
    d: "M1489.221-1506.937h16.589v15.209h-16.589Z",
    fill: "#003160"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.2c6d6f34b248b591081282de1bdf9210.svg";
export { ForwardRef as ReactComponent };